import React from "react";
import Modal from "../../../../components/elements/Modal";
import ManageFaq from "../ManageFaq";
import Drawer from "../../../../components/elements/Drawer";
import DrawerHeader from "../../../../components/elements/DrawerHeader";

const ManageFaqModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    // <Modal
    //   isOpen={open}
    //   setIsOpen={close}
    //   size="xl2"
    //   title={data?._id ? "Update" : "Create New "}
    // >
    //   <ManageFaq getResponse={getResponse} close={close} data={data} />
    // </Modal>
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl"}
      title={data?._id ? "Update" : "Create New "}
      subtitle="View, update and modify FAQ details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      // header={<DrawerHeader />}
    >
      <ManageFaq getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageFaqModal;
